import {Button, MenuItem} from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Ten99RouteConstants from 'Agent/1099s/Ten99RouteConstants';
import AccountRouteConstants from 'Agent/Accounts/AccountRouteConstants';
import {AgentInformationRouteConstants} from 'Agent/AgentInformation/AgentInformationRouteConstants';
import CommissionRouteConstants from 'Agent/Commissions/CommissionsRouteConstants';
import PolicyRouteConstants from 'Agent/Policies/PolicyRouteConstants';
import 'Core/components/Navigation/MyAccessMenu.sass';
import {
  getAndSyncSchooxUser,
  isSchooxPopupClosedEvent,
  redirectSchoox,
  toggleSchooxConfirmation,
} from 'Core/ducks/schoox';
import * as O from 'fp-ts/lib/Option';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RouteComponentProps} from 'react-router';
import {ReducerState} from 'rootReducer';
import MenuStateProvider from 'Shared/components/MenuStateProvider';
import RequireAtLeastOneScope from 'Shared/components/RequireAtLeastOneScope';
import {Scope} from 'Shared/constants/Scope';
import 'Shared/components/Modal.sass';
import {isUserEmulating} from 'Shared/utilities/impersonationHelpers';
import {Schoox} from '../Schoox';
import {ModalState, showModal} from 'Core/ducks/modal';
import {DocumentRouteConstants} from 'Agent/DocumentUploadHistory/Routes';

type MyAccessMenuProps = {
  scopes: Scope[];
} & RouteComponentProps;

export const MyAccessMenu = (props: MyAccessMenuProps) => {
  const {selectedAgency, userClaims} = useSelector((state: ReducerState) => state.user.profile);
  const {isSchooxConfirmationOpen, isLoading, isComplete, schooxUser, isSchooxPopupClosed, isSynced} = useSelector(
    (state: ReducerState) => state.schoox
  );
  const {enable_portals_virus_scan} = useSelector((state: ReducerState) => state.featureFlag);
  const isImpersonating = isUserEmulating(userClaims);
  const dispatch = useDispatch(); 
  useEffect(() => {
    if (!isSchooxConfirmationOpen && isComplete && schooxUser.isSynced && !isSchooxPopupClosed) {
      dispatch(toggleSchooxConfirmation(true));
    }
  }, [isComplete, isSynced]);

  return (
    <>
      <Schoox />
      <RequireAtLeastOneScope
        scopes={[
          Scope.SearchAccounts,
          Scope.SearchPolicies,
          Scope.SearchTaxStatements,
          Scope.SearchCommissions,
          Scope.SearchClaims,
          Scope.SearchPolicyCorrespondence,
          Scope.ViewPendingUnderwritingRequirements,
          Scope.SendServiceRequest,
          //Scope.ViewDocumentUploadHistory,
        ]}
      >
        <MenuStateProvider>
          {({anchor, close, open, firstMenuItemRef, focusFirstMenuItem}) => (
            <>
              <Button
                id="myaccess-menu-btn"
                className="my-access-menu"
                variant="text"
                onClick={event => open(event.currentTarget)}
                aria-haspopup="true"
                aria-controls="my-access-menu"
                aria-expanded={Boolean(anchor)}
              >
                My Access
                <ArrowDown />
              </Button>
              <Menu
                id="my-access-menu"
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                transformOrigin={{vertical: 'top', horizontal: 'center'}}
                getContentAnchorEl={null}
                onClose={close}
                open={Boolean(anchor)}
                anchorEl={anchor}
                TransitionProps={{onEntered: focusFirstMenuItem}}
              >
                {props.scopes?.includes(Scope.SearchTaxStatements) && (
                  <MenuItem
                    className="my-access-menu__item"
                    id="1099-myaccess-menu-btn"
                    onClick={() => {
                      props.history.push(Ten99RouteConstants.TEN99s);
                      close();
                    }}
                    ref={firstMenuItemRef}
                  >
                    1099s
                  </MenuItem>
                )}
                {props.scopes?.includes(Scope.SearchAccounts) && (
                  <MenuItem
                    id="accounts-myaccess-menu-btn"
                    className="my-access-menu__item"
                    onClick={() => {
                      props.history.push(AccountRouteConstants.ACCOUNTS);
                      close();
                    }}
                  >
                    Accounts
                  </MenuItem>
                )}
                {props.scopes?.includes(Scope.ViewAgentHierarchy) && (
                  <MenuItem
                    id="agent-hierarchy-myaccess-menu-btn"
                    className="my-access-menu__item"
                    onClick={() => {
                      props.history.push(AgentInformationRouteConstants.HIERARCHY);
                      close();
                    }}
                  >
                    Agent Hierarchy
                  </MenuItem>
                )}
                {props.scopes?.includes(Scope.AgentLicense) && (
                  <MenuItem
                    id="agent-licenses-myaccess-menu-btn"
                    className="my-access-menu__item"
                    onClick={() => {
                      props.history.push(AgentInformationRouteConstants.AGENT_LICENSES);
                      close();
                    }}
                  >
                    Agent Licenses
                  </MenuItem>
                )}
                {props.scopes?.includes(Scope.SendServiceRequest) && (
                  <MenuItem
                    className="my-access-menu__item"
                    id="policies-myaccess-menu-btn"
                    onClick={() => {
                      props.history.push(PolicyRouteConstants.POLICY_SERVICE_REQUEST);
                      close();
                    }}
                  >
                    Change Policy Service Request
                  </MenuItem>
                )}
                {props.scopes?.includes(Scope.SearchCommissionSchedules) && (
                  <MenuItem
                    id="comission-scheduleds-myaccess-menu-btn"
                    className="my-access-menu__item"
                    onClick={() => {
                      props.history.push(CommissionRouteConstants.COMMISSION_SCHEDULES);
                      close();
                    }}
                  >
                    Commission Schedules
                  </MenuItem>
                )}
                {O.isSome(selectedAgency) && selectedAgency.value.isNewYork && (
                  <MenuItem
                    className="my-access-menu__item"
                    id="rate-generators-myaccess-menu-btn"
                    onClick={() => {
                      props.history.push(AgentInformationRouteConstants.NY_RATE_GENERATORS);
                      close();
                    }}
                  >
                    Rate Generators
                  </MenuItem>
                )}
                {props.scopes?.includes(Scope.SearchCommissions) && (
                  <MenuItem
                    className="my-access-menu__item"
                    id="comissions-myaccess-menu-btn"
                    onClick={() => {
                      props.history.push(CommissionRouteConstants.COMMISSIONS);
                      close();
                    }}
                  >
                    Commissions
                  </MenuItem>
                )}
                {props.scopes?.includes(Scope.SearchPolicyCorrespondence) && (
                  <MenuItem
                    className="my-access-menu__item"
                    id="correspondence-myaccess-menu-btn"
                    onClick={() => {
                      dispatch(showModal(ModalState.CorrespondenceFilterModal()));
                      close();
                    }}
                  >
                    Correspondence
                  </MenuItem>
                )}
                 {enable_portals_virus_scan && (
                <MenuItem
                  className="my-access-menu__item"
                  id="document-upload-history-myaccess-menu-btn"
                  onClick={() => {
                    props.history.push(DocumentRouteConstants.ROOT_URI);
                    close();
                  }}
                >
                  Document Upload History
                </MenuItem>
                )}
                {props.scopes?.includes(Scope.ViewPendingUnderwritingRequirements) && (
                  <MenuItem
                    id="pending-underwriting-requirements-myaccess-menu-btn"
                    className="my-access-menu__item"
                    onClick={() => {
                      props.history.push(PolicyRouteConstants.PENDING_UNDERWRITING_REQUIREMENT);
                      close();
                    }}
                  >
                    Pending Underwriting Requirements
                  </MenuItem>
                )}
                {props.scopes?.includes(Scope.SearchPolicies) && (
                  <MenuItem
                    className="my-access-menu__item"
                    id="policies-myaccess-menu-btn"
                    onClick={() => {
                      props.history.push(PolicyRouteConstants.POLICIES);
                      close();
                    }}
                  >
                    Policies
                  </MenuItem>
                )}
                {props.scopes?.includes(Scope.SearchEnrollmentApplications) && (
                  <MenuItem
                    id="policy-applications-myaccess-menu-btn"
                    className="my-access-menu__item"
                    onClick={() => {
                      props.history.push(PolicyRouteConstants.POLICY_APPLICATIONS);
                      close();
                    }}
                  >
                    Policy Applications
                  </MenuItem>
                )}
                {props.scopes?.includes(Scope.SearchPolicyReports) && (
                  <MenuItem
                    id="policy-information-reports-myaccess-menu-btn"
                    className="my-access-menu__item"
                    onClick={() => {
                      props.history.push(AccountRouteConstants.POLICY_INFORMATION_REPORTS);
                      close();
                    }}
                  >
                    Policy Information Reports
                  </MenuItem>
                )}
                {O.isSome(selectedAgency) && !selectedAgency.value.isNewYork && (
                  <>
                    {props.scopes?.includes(Scope.AgentResources) && (
                      <>
                        {!isImpersonating && (
                          <MenuItem
                            id="training-site-myaccess-menu-btn"
                            className="my-access-menu__item"
                            onClick={() => {
                              if (!isLoading && isComplete && isSynced) {
                                dispatch(redirectSchoox());
                              } else {
                                dispatch(toggleSchooxConfirmation(true));
                                dispatch(isSchooxPopupClosedEvent(false));
                                dispatch(getAndSyncSchooxUser());
                              }
                              close();
                            }}
                          >
                            Training Resources
                          </MenuItem>
                        )}
                        <MenuItem
                          id="trainingQRT-site-myaccess-menu-btn"
                          className="my-access-menu__item"
                          onClick={() => {
                            window.open('http://allstatevoluntary.com/qrt/qrtrd.php');
                            close();
                          }}
                        >
                          Quoting & Add'l Info
                        </MenuItem>
                      </>
                    )}
                  </>
                )}
              </Menu>
            </>
          )}
        </MenuStateProvider>
      </RequireAtLeastOneScope>
    </>
  );
};

export default MyAccessMenu;
